import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractEntityDataProvider } from '@entity-framework/entity-record/entity-data-provider/abstract-entity.data-provider';
import { LoggingService } from '@logging/logging.service';
import { ContactUsFormData } from './contact-us.model';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactUsDataProvider extends AbstractEntityDataProvider<ContactUsFormData> {
  protected apiRoot = `${environment.apiPaths.root}contactus`;

  constructor(
    protected override httpClient: HttpClient,
    protected override logger: LoggingService
  ) {
    super(httpClient, logger);
  }
  
} 